import { z } from 'zod';

export const WorkflowWritebackMergeAuthMethod = z.object({
  type: z.literal('merge'),

  /**
   * The data set ID that refers to the Merge ATS data set.
   */
  dataSetId: z.string().optional(),
});

export type WorkflowWritebackMergeAuthMethod = z.infer<
  typeof WorkflowWritebackMergeAuthMethod
>;
